'use client';

import React, { useState } from 'react';
import AddOnSearchBar from 'components/AddOns/AddOnsSearchBar/AddOnSearchBar';
import FiltersAddOns from 'components/AddOns/AddOnsFilters/FiltersAddOns';
import AddOnsEmptyState from 'components/AddOns/AddOnsEmptyState/AddOnsEmptyState';
import PaginationControls from 'components/Pagination/PaginationControls';
import styles from './AddOnsPageLayout.module.scss';

/**
 * Layout: Filters on left edge (not aligned with content).
 * Search bar + add-ons centered, aligned with intro text above
 */
export default function AddOnsPageLayout({
    filters = [],
    displayAddOns,
    currentPage,
    totalPages,
    totalItems,
    perPageFromApi,
    hasActiveFilters = false,
    hasSelectedFilters = false,
}) {
    const [filtersVisible, setFiltersVisible] = useState(true);
    const hasFilters = filters?.length > 0;
    const shouldShowFiltersContainer = hasFilters && (filtersVisible || hasSelectedFilters);

    const handleFiltersToggle = () => {
        setFiltersVisible((prev) => !prev);
    };

    return (
        <div
            className={styles.layoutWrapper}
            data-filters-hidden={!shouldShowFiltersContainer}
        >
            {shouldShowFiltersContainer && (
                <aside className={styles.filtersSidebar}>
                    <FiltersAddOns
                        key="filters-desktop"
                        filters={filters}
                        showActiveFiltersOnly={!filtersVisible}
                    />
                </aside>
            )}

            <div
                className={styles.contentArea}
                style={!filtersVisible ? { width: '100%' } : undefined}
            >
                <div className={styles.contentInner}>
                    <AddOnSearchBar
                        filtersVisible={filtersVisible}
                        onFiltersToggle={handleFiltersToggle}
                        hasFilters={hasFilters}
                    />

                    {shouldShowFiltersContainer && (
                        <div className={styles.filtersInline}>
                            <FiltersAddOns
                                key="filters-mobile"
                                filters={filters}
                                inline
                                showActiveFiltersOnly={!filtersVisible}
                            />
                        </div>
                    )}

                    {totalItems === 0 ? (
                        <AddOnsEmptyState hasActiveFilters={hasActiveFilters} />
                    ) : (
                        displayAddOns
                    )}

                    <PaginationControls
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        perPage={perPageFromApi}
                    />
                </div>
            </div>
        </div>
    );
}
